require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M41.668 8.332H8.332A4.166 4.166 0 0 0 4.168 12.5v25c0 2.3 1.863 4.168 4.164 4.168h33.336c2.3 0 4.164-1.867 4.164-4.168v-25c0-2.3-1.863-4.168-4.164-4.168zm0 8.336L25 27.082 8.332 16.668V12.5L25 22.918 41.668 12.5zm0 0"
  }));
};

exports["default"] = _default;